import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: 32,
    },
    header: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
    },
    dropdownContainer: {
      marginTop: 32,
      display: "flex",
    },
    countryCodeSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    phoneNumberSection: {
      marginLeft: 8,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    codeDropdown: {
      width: 75,
      marginTop: 8,
    },
    phoneNumberText: {
      width: 277,
      marginTop: 8,
      textAlign: "left",
    },
    codeLabel: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
    },
    phoneNumberLabel: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
    },
    flag: {},
    countryName: {
      marginLeft: 8,
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
    },
    countryCode: {
      marginLeft: 8,
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
    },
    receiveSmsButton: {
      marginTop: 32,
    },
    cancelButton: {
      marginTop: 32,
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    errorIcon: {
      color: theme.colors.error,
      fontSize: 16,
      marginRight: 8,
    },
    errorMessage: {
      ...theme.fonts.caption,
    },
    apiError: {
      marginTop: 32,
      textAlign: "left",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
